import { Injectable } from '@angular/core';
import { BaseService, Pagination } from '../core';
import { BuyerCoupon } from '../dto/coupon/buyer-coupon.entity';
import { BuyerCouponCreateDto, CheckCouponCodeDto, CouponListDto, CouponSetting } from '../dto/coupon';
import { Store } from '@ngrx/store';
import * as IndicatorStore from '../store/indicator';
import { mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Cart } from '../dto';
import { Utils } from '../common';
import { COUPON_USABLE_TYPE } from '../shared/common-code.type';

@Injectable({
  providedIn: 'root',
})
export class CouponService extends BaseService {
  constructor(private store: Store<any>) {
    super();
  }
  getCouponList(couponListDto: CouponListDto, pagination: Pagination) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('getCouponList'));
    return super.paginate<BuyerCoupon>('/coupon', couponListDto, pagination).pipe(
      mergeMap((paginatedCoupon) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('getCouponList'));
        return of(paginatedCoupon);
      })
    );
  }

  caculateDiscountAmount(coupon: BuyerCoupon, shippingFee?: any) {
    let discountAmount = 0;
    if (coupon.couponSetting.couponUsableType === COUPON_USABLE_TYPE.SHIPPING && shippingFee) {
      discountAmount = Utils.getUSDToFixed(shippingFee * (coupon.couponSetting.discountRate / 100));
    } else if (coupon.couponSetting.couponUsableType === COUPON_USABLE_TYPE.UQUICK) {
      discountAmount = Utils.getUSDToFixed(coupon.sumCouponItemPrice * (coupon.couponSetting.discountRate / 100));
    } else {
      discountAmount = Utils.getUSDToFixed(coupon.sumItemPrice * (coupon.couponSetting.discountRate / 100));
    }
    if (coupon.couponSetting.maxDiscount && discountAmount > coupon.couponSetting.maxDiscount) {
      discountAmount = coupon.couponSetting.maxDiscount;
    }
    return discountAmount;
  }

  checkCouponCode(body: CheckCouponCodeDto): Observable<CouponSetting> {
    return this.post<CouponSetting>('/coupon/check/coupon-code', body);
  }

  createBuyerCoupon(couponCreateDto: BuyerCouponCreateDto) {
    return super.post<{ isSuccess: boolean }>('/coupon', couponCreateDto.filteredGet());
  }
}
